'use client';

import { FC } from 'react';
import { User } from 'lucia';
import { Button } from '@mantine/core';
import Image from 'next/image';
import Link from 'next/link';
import { IconBrandTwitch } from '@tabler/icons-react';
import classes from './UserMenu.module.css';
import { UserNariPoints } from './UserNariPoints';
import { logout } from '@/app/actions';

interface UserMenuProps {
    user: User | null;
}

export const UserMenu: FC<UserMenuProps> = ({ user }) => {
    if (!user) {
        return (
            <Button
              variant="outline"
              color="white"
              size="md"
              component="a"
              href="/login/twitch"
              leftSection={<IconBrandTwitch />}
            >
                Login
            </Button>
        );
    }

    const userImage = <Image
      src={user.profileImage}
      alt={user.displayName}
      width={40}
      height={40}
      style={{ borderRadius: '50%', padding: '5px' }}
    />;

    const doLogout = async () => {
        await logout();
    };

    return (
        <div className={classes.buttonContainer}>
            <Link href="/u/[displayName]" as={`/u/${user.displayName}`} passHref>
                { userImage }
            </Link>
            <Button
              variant="transparent"
              color="white"
              size="md"
              onClick={doLogout}
              title="Abmelden"
            >
                <div className={classes.userButton}>
                    <span className={classes.displayName}>{ user.displayName }</span>
                </div>
            </Button>
            { (user.roles.admin || (user.credits ?? 0) > 0) && <UserNariPoints /> }
        </div>
    );
};
